import { render, staticRenderFns } from "./teacher_header.vue?vue&type=template&id=2efc1e21&"
import script from "./teacher_header.vue?vue&type=script&lang=js&"
export * from "./teacher_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports